import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";

import {
  editCompanyOnSubmit,
  createCompanyOnSubmit,
  initializeEditCompany,
  settingsCompanyOnLoad,
  deleteCompany,
} from "features/planner/planner.actions";

import {
  ACTIONS,
  COMPANY_FORM,
  SORT_DIRECTION,
} from "features/planner/planner.constants";

import {
  getSummarizedDataStatesFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import CrudBasePage from "app/components/CrudBasePage";
import { getAccessControlButton } from "utils/component.util";
import { getCompaniesFromState } from "features/planner/planner.selectors";
import { getModifiedByValue, hasRequiredAccessLevel } from "utils/app.util";
import CompanyForm from "features/planner/settings/company/components/CompanyForm";

const SettingsCompanyContainer = ({
  Icon,
  companies,
  dataState,
  breadcrumb,
  dispatchOnLoad,
  crudAccessLevel,
  currentUserAppRoles,
  dispatchDeleteCompany,
  dispatchEditCompanyOnSubmit,
  dispatchCreateCompanyOnSubmit,
  dispatchInitializeEditCompany,
}) => {
  useEffect(() => {
    dispatchOnLoad();
  }, [dispatchOnLoad]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: item => item.get("name"),
      },
      {
        xs: true,
        title: "Country",
        getSortProperty: item => item.get("countryName"),
      },
      {
        xs: true,
        component: Grid,
        title: "Modified by",
        getValue: getModifiedByValue,
        getSortProperty: item => item.get("modifiedBy"),
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteCompany,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteCompany],
  );

  const companyForm = {
    form: COMPANY_FORM.ID,
  };

  return (
    <CrudBasePage
      Icon={Icon}
      title={breadcrumb}
      items={companies}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      EditEntityFormComponent={CompanyForm}
      CreateEntityFormComponent={CompanyForm}
      SortableListProps={{
        defaultSortColumn: 0,
        actions: actions,
        columns: columns,
        getKey: crew => crew.get("id"),
        defaultSortDirection: SORT_DIRECTION.ASC,
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditCompany
          : null,
      }}
      EditModalProps={{
        submitText: "Save",
        title: "Edit company",
        formTitleField: COMPANY_FORM.NAME,
        onSubmit: dispatchEditCompanyOnSubmit,
        DialogProps: { maxWidth: "md" },
      }}
      CreateModalProps={{
        submitText: "Add",
        title: "Add company",
        onSubmit: dispatchCreateCompanyOnSubmit,
        DialogProps: { maxWidth: "md" },
      }}
      editEntityForm={companyForm}
      createEntityForm={companyForm}
    />
  );
};

export default compose(
  connect(
    state => ({
      companies: getCompaniesFromState(state),
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.SETTINGS_COMPANY_ON_LOAD,
      ),
    }),
    {
      dispatchOnLoad: settingsCompanyOnLoad,
      dispatchEditCompanyOnSubmit: editCompanyOnSubmit,
      dispatchDeleteCompany: deleteCompany,
      dispatchInitializeEditCompany: initializeEditCompany,
      dispatchCreateCompanyOnSubmit: createCompanyOnSubmit,
    },
  ),
)(SettingsCompanyContainer);
